// src/components/Speakers.js
export default function Resources() {
    return (
      <div className="p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">Speakers</h2>
        <p className="text-lg">
          Hear from leading experts in health and safety, including:
          <br />
          - John Doe, Occupational Safety Specialist
          <br />
          - Jane Smith, Environmental Management Expert
          <br />
          - Michael Johnson, Fire Safety Consultant
        </p>
      </div>
    );
  }
  